import { render, staticRenderFns } from "./TipoTransporte.vue?vue&type=template&id=42b4c056&"
import script from "./TipoTransporte.vue?vue&type=script&lang=js&"
export * from "./TipoTransporte.vue?vue&type=script&lang=js&"
import style0 from "./TipoTransporte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports